import { Building2 } from 'lucide-react'

interface FinancialAccountsSectionTitleProps {
  title: string
  subtitle: string
}

/**
 * Title and subtitle of a section card on the Financial Accounts pages
 * (Connections, Manual Financial Accounts). One component so both sections
 * keep the prototype's typography; the action buttons stay with each section.
 */
export function FinancialAccountsSectionTitle({ title, subtitle }: FinancialAccountsSectionTitleProps) {
  return (
    <div className="min-w-0">
      <div className="flex items-center gap-3">
        <Building2 aria-hidden="true" className="h-5 w-5 shrink-0" />
        <h2 className="text-[22px] font-extrabold tracking-tight">{title}</h2>
      </div>
      <p className="mt-1.5 text-[15px] text-slate-400">{subtitle}</p>
    </div>
  )
}

/**
 * Restyles saas-ui `EmptyState` for a section's empty list. EmptyState has no
 * slot props, so its icon, title and text are styled from the wrapper.
 */
export const SECTION_EMPTY_STATE_CLASS =
  '[&>h3]:text-[16.5px] [&>h3]:text-slate-600 [&>p]:text-slate-400 [&>svg]:h-9 [&>svg]:w-9 [&>svg]:text-slate-300'
